// extracted by mini-css-extract-plugin
export default {"HeaderAdmin":"HeaderAdmin_HeaderAdmin__2jBrO","headerInner":"HeaderAdmin_headerInner__tthqB","active":"HeaderAdmin_active__lKbAY"};